import { getController, postController } from '@/controllers/request';
import { mixin } from '@/utils/mixins';

export default {
  namespaced: true,
  state: {
    comments: [],
    hasNoRights: false,
    commentFormActive: false,
    commentToDelete: null,
    resizeValue: 0,
    loadedTabs: {},
    tabKey: {},
    activeSubpanel: {},
    activeSubpanelData: {},
    subpanels: [],
    selectedMessage: null,
    emailPanelData: {},
    emailParams: {},
    loading: {},
    activeFilterIntent: null
  },
  mixins: [mixin],
  mutations: {
    setActiveSubpanelData(state, obj) {
      //если добавляются данные по новой вкладке
      if (obj?.tabName && obj?.data) {
        state.activeSubpanelData = { ...state.activeSubpanelData };
        state.activeSubpanelData[obj.tabName] = obj.data;
      }
      //если нужно удалить/изменить данные только отдельных кладок
      //(старые данные по непереданным вкладкам будут удалены)
      else if (Object.keys(obj).length) {
        state.activeSubpanelData = obj;
      }
      //очистка данных по всем вкладкам
      else {
        state.activeSubpanelData = {};
      }
    },
    setLoadingTab(state, { module, data }) {
      state.loading = { ...state.loading };
      state.loading[module] = data;
    },
    setActiveSubpanel(state, { module, activeSubpanel }) {
      state.activeSubpanel = { ...state.activeSubpanel };
      state.activeSubpanel[module] = activeSubpanel;
    },
    setSubpanels(state, subpanels) {
      state.subpanels = subpanels;
    },
    setComents(state, comments) {
      state.comments = comments;
    },
    setRights(state, val) {
      state.hasNoRights = val;
    },
    setCommentForm(state, val) {
      state.commentFormActive = val;
    },
    setCommentToDelete(state, value) {
      state.commentToDelete = value;
    },
    setResizeSidebarValue(state, data) {
      state.resizeValue = data;
    },
    setLoadedTabs(state, { tab, loaded }) {
      state.loadedTabs[tab] = loaded;
    },
    // setActiveSubpanel(state, { i, data = {} }) {
    //   state.activeSubpanel = { ...state.activeSubpanel, [i]: data };

    //   if (!state.tabKey.hasOwnProperty(data.id)) {
    //     state.tabKey[data.id] = 0;
    //   }
    // },
    updateActiveSubpanel(state, id) {
      if (id) {
        state.tabKey = { ...state.tabKey, [id]: +(state.tabKey[id] || 0) + 1 };
      } else {
        for (let key in state.tabKey) {
          state.tabKey = {
            ...state.tabKey,
            [key]: +(state.tabKey[key] || 0) + 1
          };
        }
      }
    },
    setSelectedMessage(state, messageData = null) {
      state.selectedMessage = messageData;
    },
    setEmailData(state, val) {
      state.emailPanelData = val;
    },
    setEmailParams(state, val) {
      state.emailParams = val;
    },
    setFiltersData(state, { module, data }) {
      if (state.activeSubpanelData[module]?.custom_search) {
        state.activeSubpanelData[module].custom_search = {
          checkIndication: true,
          ...data
        };
      }
    },
    setParams(state, { name, value }) {
      state[name] = value;
    }
  },
  actions: {
    async getDataForTab({ state, commit, rootState }, { module, tab }) {
      commit('setLoadingTab', { module: module, data: true });

      let request = tab.intents[0];

      if (
        module == 'HRPAC_VACANCY' &&
        tab.id == 'candidates' &&
        rootState.filters.filterAdditionalUrl['vacancy_candidates'] &&
        rootState.filters.filterAdditionalUrl['vacancy_candidates'].length
      ) {
        request.request.request_params['hidden_stage_ids'] =
          rootState.filters.filterAdditionalUrl['vacancy_candidates'].split(
            '&hidden_stage_ids[]='
          );
        state.activeFilterIntent = request;
      }

      try {
        //TODO исправить работу контроллеров
        const response = await mixin.methods.sendFormRequestFromIntent(request);
        // const response = await getController({
        //   url: tab.intents[0].request.url,
        //   params: { ...tab.intents[0].request.request_params }
        // });

        commit('setActiveSubpanelData', {
          tabName: tab.id,
          data: response.data?.panels || response.data
        });

        if (tab.id == 'candidates' || tab.id == 'responds') {
          commit(
            'common/setTableData',
            {
              module:
                tab.id == 'candidates'
                  ? 'vacancy_candidates'
                  : tab.id == 'responds'
                  ? 'vacancy_responds'
                  : '',
              columns: response.data.data.data.data.title,
              rows: response.data.data.data.data.rows,
              message: response.data.data.data.data.message || ''
            },
            { root: true }
          );
          commit(
            'common/setParam',
            {
              name: 'tableFields',
              val: response?.data?.sugarconfig
            },
            {
              root: true
            }
          );
          commit(
            'selectionPopup/setMetadataFields',
            response.data.sugarconfig,
            { root: true }
          );
          commit(
            'selectionPopup/popupPageConfig',
            response.data.data.pageData,
            { root: true }
          );
          commit('filters/setFiltersConfig', response.data.custom_search, {
            root: true
          });
          commit('filters/setFiltersActive', false, {
            root: true
          });
          commit('filters/setSortActive', false, {
            root: true
          });
        }

        if (tab.id == 'comments') {
          commit('setComents', response.data || []);
        }
      } catch (error) {
        console.error(error);
      } finally {
        commit('setLoadingTab', {
          module: module,
          data: false
        });
      }
    },
    async updateDataForVacancyCandidates({ commit, state }, intent) {
      commit(
        'rightPanel/setParam',
        {
          name: 'loading',
          val: true
        },
        { root: true }
      );

      state.activeFilterIntent = intent;

      commit('setLoadingTab', { module: 'HRPAC_VACANCY', data: true });
      try {
        const response = await getController({
          url: intent.request.url,
          params: { ...intent.request.request_params }
        });

        commit(
          'common/setTableData',
          {
            module: 'vacancy_candidates',
            columns: response.data.data.data.data.title,
            rows: response.data.data.data.data.rows
          },
          { root: true }
        );
        commit(
          'common/setParam',
          {
            name: 'tableFields',
            val: response?.data?.sugarconfig
          },
          {
            root: true
          }
        );

        commit('selectionPopup/setMetadataFields', response.data.sugarconfig, {
          root: true
        });

        commit('selectionPopup/popupPageConfig', response.data.data.pageData, {
          root: true
        });
        commit('filters/setFiltersConfig', response.data.custom_search, {
          root: true
        });

        commit(
          'subpanels/setActiveSubpanelData',
          {
            tabName: 'candidates',
            data: response?.data?.panels || response?.data
          },
          {
            root: true
          }
        );
      } catch (error) {
        console.error(error);
      } finally {
        commit('setLoadingTab', { module: 'HRPAC_VACANCY', data: false });
        commit(
          'rightPanel/setParam',
          {
            name: 'loading',
            val: false
          },
          { root: true }
        );
      }
    },
    async loadComments({ commit }, intent) {
      try {
        const { data } = await mixin.methods.sendFormRequestFromIntent(intent);

        if (!data.error) {
          commit('setComents', data);
        } else {
          commit('setRights', true);
        }
      } catch (e) {
        console.error(e);
      }
    },
    async saveComment(ctx, { options }) {
      await postController({ options });
    },
    async confirmDeleteComment(ctx, { options }) {
      await postController({ options });
    }
  }
};
